// Dock section wrapping `SalesDailyChecklistWidget` so the daily
// sales-checklist can live in the activity dock alongside the other
// registered sections (active-lead checklist, ads activity card,
// achievements) instead of being wedged into the `LeadsModePanel`
// left rail.
//
// Slice C of docs/planning/activity_dock_workflow_facilitation.md §6.
// The widget already handles its own data fetching + UI state via
// `useSalesDailyChecklistWidget(scopedOrgId)`; this wrapper just
// supplies the `scopedOrgId` from `WorkspaceOrgContext` plus the
// optional navigation callbacks that the surrounding shell wires
// through the render context. The widget's optional callbacks
// degrade gracefully when unset (in-row CTAs skip themselves and
// the follow-up alert returns null), but Slice C plumbs all of
// them through so the user-facing behavior of the widget stays
// identical to its previous left-rail mount.
//
// `null` when `scopedOrgId` is unset — matches the widget's own
// short-circuit so platform-without-org / unauthenticated states
// don't render an empty card.

import { useScopedOrganizationId } from "@/contexts/WorkspaceOrgContext";
import { SalesDailyChecklistWidget } from "@/components/lead/sections/SalesDailyChecklistWidget";

export type ActivityDockDailyChecklistSectionProps = {
  onOpenAdsAssistant?: () => void;
  onOpenAdsAssistantSuggestion?: () => void;
  onOpenSalesConsole?: () => void;
  followUpAttentionCount?: number;
};

export function ActivityDockDailyChecklistSection(
  props: ActivityDockDailyChecklistSectionProps,
) {
  const scopedOrgId = useScopedOrganizationId();
  if (!scopedOrgId) return null;
  return (
    <SalesDailyChecklistWidget
      scopedOrgId={scopedOrgId}
      onOpenAdsAssistant={props.onOpenAdsAssistant}
      onOpenAdsAssistantSuggestion={props.onOpenAdsAssistantSuggestion}
      followUpAttentionCount={props.followUpAttentionCount ?? 0}
      onOpenSalesConsole={props.onOpenSalesConsole}
    />
  );
}
